import type {
    AbstractAnalyticsDispatcher,
    OverridableActionsTypes,
    OverridableBusinessEventTypes,
} from "@asurion-core/eventualize";
import type { Logger } from "@expert/logging";

import { useEffect, useMemo, useState } from "react";

interface SimplrInitializersProps {
    dispatcher: AbstractAnalyticsDispatcher<OverridableBusinessEventTypes, OverridableActionsTypes>;
    isLoading: boolean;
    logger: Logger;
    currentStepId: string;
    opened: boolean;
}

export function useDelayTracking({
    currentStepId,
    isLoading,
    logger: loggerProp,
    dispatcher,
    opened,
}: SimplrInitializersProps) {
    const logger = useMemo(() => loggerProp.child({ module: "useDelayTracking" }), [loggerProp]);
    const [loadingStart, setLoadingStart] = useState<{ previousStepId?: string; startTime: number }>({
        previousStepId: "",
        startTime: 0,
    });

    useEffect(() => {
        if (!opened) {
            return setLoadingStart({ previousStepId: "", startTime: 0 });
        }
        const { previousStepId } = loadingStart;
        if (!isLoading && previousStepId) {
            const loadingFinish = performance.now();
            const delayInSeconds = (Math.floor(loadingFinish - loadingStart.startTime) / 1000).toFixed(2);

            const payload = {
                from: previousStepId,
                to: currentStepId,
                delayInSeconds: delayInSeconds,
            };
            void dispatcher.dispatchAction("StepLoaded", "Guide", payload);
            logger.info(
                payload,
                `Solve Guide | ${previousStepId} -> ${currentStepId} loaded after ${delayInSeconds}s.`,
            );
        } else if (isLoading) {
            setLoadingStart({ previousStepId: currentStepId, startTime: performance.now() });
        }
        // oxlint-disable-next-line exhaustive-deps
    }, [isLoading]);
}
